import { createFileRoute, redirect } from '@tanstack/react-router'
// import { ResellerInvoicesPage } from '@/features/reseller/pages/invoices'

/** Invoices are temporarily disabled; redirect manual URL access to home. */
export const Route = createFileRoute('/_authenticated/reseller/invoices')({
  // component: ResellerInvoicesPage,
  beforeLoad: () => {
    throw redirect({ to: '/reseller', replace: true })
  },
})
